export default value => {
  // - 需放最後，不然要會跟 0-9 的 - 混淆
  const patt = /^09\d{8}$/

  if (patt.test(value)) return null

  return '手機號碼錯誤'
}
